import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import './NavBranding.scss';

const NavBranding = ({
  target, alt, text,
}) => {
  const history = useHistory();
  return (
    <div className="logo-container">
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a title={alt} className="navbar-brand" onClick={() => history.push(target)}>
        <img src="/images/logo-cropped.png" alt={text} />
      </a>
      <span className="tag-line">{alt}</span>
    </div>
  );
};

NavBranding.propTypes = {
  target: PropTypes.string,
  alt: PropTypes.string,
  text: PropTypes.string,
};

NavBranding.defaultProps = {
  target: undefined,
  alt: '',
  text: '',
};

export default NavBranding;
